export const ProductDeliveryOptionItemListSkeleton = () => (
  <div className="flex flex-col divide-y divide-grey-300 border border-grey-300">
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="p-4">
        <div className="skeleton h-16" />
      </div>
    ))}
  </div>
);
